import { metrics } from '@atlassian/browser-metrics';

export const projectComponentsPageLoad = metrics.pageLoad({
	key: 'project-components',
	ssr: {
		doneAsFmp: true,
	},
});
